import preventIcon from '@/assets/prevention-back.jpg';
export default {
  name: 'PreventionGuide',

  setup() {
    return {
      preventIcon
    };
  }

};